export class User {
  Name: string;
  Name1: string;
  UserID: number;
  CustomerId: number;
  IsFirstTimeLogin: boolean;
  UserName: string;
  ApplicantType: string;
  Nationality: string;
  Nationality1: string;
  ExpiresOn: Date;
  CommunicationAddress: string;
  CommunicationCity: string;
  CommunicationState: string;
  CommunicationCountry: string;
  CommunicationPinCode: string;
  SecondaryApplicantCommunicationAddress: string;
  SecondaryApplicantCommunicationCity: string;
  SecondaryApplicantCommunicationState: string;
  SecondaryApplicantCommunicationCountry: string;
  SecondaryApplicantCommunicationPincode: string;
  PassportNumber: string;
  AadharNumber: string;
  AuthPersonAadharNo: string;
  AuthPersonName: string;
  PassportNumber1: string;
  AadharNumber1: string;
  AlternateMobileNumber: string;
  SecondaryApplicantPrimaryMobileNumber: string;
  SecondaryApplicantAlternateMobileNumber: string;
}
